<template>
  <v-app>
    <v-app-bar
      class="flex-grow-0"
      color="primary"
      dark
      flat
      v-if="$route.name !== 'Signin'">
      <div class="d-flex align-center app_nav flex-grow-1">
        <!-- <v-app-bar-nav-icon @click.stop="drawer = !drawer"></v-app-bar-nav-icon> -->
        <!-- <v-toolbar-title>
          <router-link class="white--text text-decoration-none" :to="{ name: 'Home' }">Билборды</router-link>
        </v-toolbar-title> -->
        <div class="d-flex align-center app_nav-links">
          <router-link
            class="mr-5 white--text text-decoration-none"
            :to="{ name: 'Home' }"
            :class="{ 'is-active': $route.name === 'Board' }">
            Головна
          </router-link>
          <router-link
            v-if="isAuthenticated && isAdmin"
            class="mr-5 white--text text-decoration-none"
            :to="{ name: 'Constructions' }">
            Конструкції
          </router-link>
          <router-link
            v-if="isAuthenticated && isAdmin"
            class="mr-5 white--text text-decoration-none"
            :to="{ name: 'Places' }">
            Населені пункти
          </router-link>
          <router-link
            v-if="isAuthenticated && isAdmin"
            class="white--text text-decoration-none"
            :to="{ name: 'Owners' }"
            :class="{ 'is-active': $route.name === 'Owner' }">
            Оператори
          </router-link>
        </div>
        <v-spacer></v-spacer>
        <v-btn
          v-if="!isAuthenticated"
          icon
          :to="{ name: 'Signin' }"
          title="Авторизація"
          aria-label="Авторизація">
          <v-icon>mdi-login</v-icon>
        </v-btn>
        <v-btn v-else icon title="Вийти" aria-label="Вийти" @click="logout">
          <v-icon>mdi-logout-variant</v-icon>
        </v-btn>
      </div>
    </v-app-bar>

    <v-main>
      <router-view />
    </v-main>
  </v-app>
</template>

<script>
import { LOGOUT } from '@/store/auth/types';

export default {
  name: 'App',

  data: () => ({
    //
  }),
  computed: {
    isAuthenticated() {
      return this.$store.getters.isAuthenticated;
    },
    isAdmin() {
      return this.$store.getters.isAdmin;
    },
  },
  methods: {
    logout() {
      this.$store.dispatch(LOGOUT).catch(() => {
        console.error('Не вдалося перейти на головну після виходу.');
      });
    },
  },
};
</script>

<style lang="scss">
.app_nav {
  height: 100%;
  min-width: 0;

  .app_nav-links {
    height: 100%;
    min-width: 0;
    overflow-x: auto;
    white-space: nowrap;
  }

  a {
    flex-shrink: 0;
    opacity: 0.5;
    height: 100%;
    display: flex;
    align-items: center;
    position: relative;

    &::before {
      content: '';
      position: absolute;
      width: 100%;
      height: 2px;
      background-color: currentColor;
      top: -4px;
      left: 0;
      opacity: 0;
    }
    &.is-active,
    &.router-link-exact-active {
      opacity: 1;

      &::before {
        opacity: 1;
      }
    }
  }
}
.v-input.is-required .v-label::after {
  content: ' *';
  color: var(--v-error-base);
}
</style>
